import { consumer, payloadToJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  isInitialized: boolean;
  isInitializedOnBrowser: boolean;
  wasJustInitializedFromSSR: boolean;
  result?: consumer.BusinessAvailabilitySearchResponse;
  requestInProgress: boolean;
  shouldScrollToTopOnNewResults: boolean;
}

const initialState: State = {
  isInitialized: false,
  isInitializedOnBrowser: false,
  wasJustInitializedFromSSR: false,
  result: undefined,
  requestInProgress: false,
  shouldScrollToTopOnNewResults: false,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.AVAILABILITY_SET_SCROLL_TO_TOP: {
      return {
        ...state,
        shouldScrollToTopOnNewResults: payload,
      };
    }
    case AppConstants.AVAILABILITY_SEARCH_CLEAR: {
      return {
        ...state,
        isInitialized: false,
        result: undefined,
        shouldScrollToTopOnNewResults: false,
      };
    }
    case AppConstants.AVAILABILITY_SEARCH_DONE: {
      const result = payloadToJSON<consumer.BusinessAvailabilitySearchResponse>(payload);
      return {
        ...state,
        isInitialized: true,
        isInitializedOnBrowser: typeof window !== 'undefined',
        wasJustInitializedFromSSR: typeof window === 'undefined',
        result,
        requestInProgress: false,
        shouldScrollToTopOnNewResults: true,
      };
    }
    case AppConstants.AVAILABILITY_SEARCH_STARTING: {
      return {
        ...state,
        requestInProgress: BROWSER ? true : state.isInitializedOnBrowser,
        shouldScrollToTopOnNewResults: false,
      };
    }
    case AppConstants.AVAILABILITY_SEARCH_FAILED: {
      return {
        ...state,
        isInitialized: false,
        requestInProgress: false,
        shouldScrollToTopOnNewResults: false,
      };
    }
    case AppConstants.AVAILABILITY_CLEAR_SSR_INITIALIZATION: {
      return { ...state, wasJustInitializedFromSSR: false };
    }

    case AppConstants.AVAILABILITY_RESET_SSR_INITIALIZATION: {
      return { ...state, wasJustInitializedFromSSR: true };
    }

    default:
      return state;
  }
}
